const defaultAddToHomeConfig = {
  enabledForIOS: false,
  enabledForAndroid: false,
  enableAddToHomeV3: false,
  dashboard: {
    addToHomeBtn: {
      label: "ADD_TO_HOMEV3",
      margin: "0 6px 0 6px",
      padding: "4px 25px 4px 25px",
      fontSize: "14px",
      colorConfig: {
        light: {
          textColor: "#fff",
          backgroundColor: "#2ea40f"
        },
        dark: {
          textColor: "#fff",
          backgroundColor: "#2ea40f"
        }
      }
    }
  },
  addToHomePopUp: {
    addBtn: {
      label: "ADD_NOW",
      margin: "",
      padding: "10px 20px 10px 20px",
      fontSize: "14px",
      colorConfig: {
        light: {
          textColor: "#fff",
          backgroundColor: "#2ea40f"
        },
        dark: {
          textColor: "#fff",
          backgroundColor: "#2ea40f"
        }
      }
    },
    otherBtn: {
      label: "DONT_ASK_AGAIN_TEXT",
      margin: "",
      padding: "10px 20px 10px 20px",
      fontSize: "14px",
      colorConfig: {
        light: {
          textColor: "#000000",
          backgroundColor: "",
        },
        dark: {
          textColor: "#fff",
          backgroundColor: "",
        }
      }
    }
  }
};

const defaultTransactionSummaryConfig = {
  continueBtn: {
    label: "CONTINUE",
    padding: "13px 0 13px 0",
    margin: "0 0 0 20px",
    fontSize: "12px",
    colorConfig: {
      light: {
        textColor: "#fff",
        backgroundColor: "#232530"
      },
      dark: {
        textColor: "#0f0f0f",
        backgroundColor: "#fff"
      }
    }
  }
};

export { defaultAddToHomeConfig, defaultTransactionSummaryConfig };